import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { handlePost } from '../../../utils/AxiosUtil';
import ErrorAwareDatePicker from '../inputfields/ErrorAwareDatePicker';

class CloseObject extends Component {
    state = {
        validUntil: null,
        errors: new Map()
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = this.props.path;
        const requestObject = {
            "privateId": this.props.row.privateId,
            "validUntil": this.state.validUntil,
        };
        handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='input-group'>
                    <ErrorAwareDatePicker
                        required
                        name="validUntil"
                        label={this.props.datePickerlabel}
                        errors={this.state.errors}
                        value={this.state.validUntil}
                        onChange={event => this.setState({ validUntil: event })} />
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Igen
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(CloseObject);
